export default "__VITE_PUBLIC_ASSET__a878c675__"